import { api } from './api';

const VID_KEY = 'byanfal_vid';
const SID_KEY = 'byanfal_sid';

function uuid() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
}

export function getVisitorId() {
    let v = localStorage.getItem(VID_KEY);
    if (!v) { v = uuid(); localStorage.setItem(VID_KEY, v); }
    return v;
}

export function getSessionId() {
    let s = sessionStorage.getItem(SID_KEY);
    if (!s) { s = uuid(); sessionStorage.setItem(SID_KEY, s); }
    return s;
}

export async function track(type, payload = {}) {
    try {
        await api.post('/track', {
            visitor_id: getVisitorId(),
            session_id: getSessionId(),
            type,
            ...payload,
        });
    } catch (e) {
        // Tracking must never break UX
    }
}
